"use strict";

module.exports = require("./is-implemented")()
	? Array.from
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/array/from/index.js
// module id = 199
// module chunks = 0